import { Component, OnInit, Optional, Input } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import * as Services from '@shared/core/services';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-loyalty-hero-header',
    templateUrl: './loyalty-hero-header.shared.component.html',
    styleUrls: ['./loyalty-hero-header.shared.component.scss']
})
export class LoyaltyHeroHeaderComponent implements OnInit {
    public preHead: string = 'GOOD MORNING';

    @Input() public marginBottom: OLO.Components.MARGIN_SIZE = 'md';
    @Input() public btnSize: OLO.Components.BUTTON_SIZE = 'lg';
    @Input() public btnAccountFeel: OLO.Components.BUTTON_FEEL = 'primary';
    @Input() public btnSignInFeel: OLO.Components.BUTTON_FEEL = 'secondary';

    @Input() public text: string[] = [];

    constructor(
        public controllers: Controllers,
        @Optional() public authService: Services.AuthService,
    ) { }

    ngOnInit(): void {
        if (new Date().getHours() >= 12) {
            this.preHead = 'GOOD AFTERNOON';
        }

        if (!this.text.length) {
            this.text = this.controllers.loyalty.getLoyaltyHeaderText();
        }
    }

    public handleCreateAccountClick($event: Event): void {
        this.controllers.loyalty.createAccountWithMemberCard();
    }

    public handleSignInClick($event: Event): void {
        this.controllers.members.openMemberSignInForm();
    }

    public get center(): boolean {
        return false;
    }

    public get headerType(): OLO.Components.HEADER_TYPE {
        return window.innerWidth < 768 ? '3' : '1';
    }
}
